import pkg from "../../package.json";
import "./Version.css"; 

export default function Version() {
  return (
    <div className="main_login">
      <div className="form_login">
        <div className="container version_box">
          <div className="version_value">{pkg.version}</div>
        </div>
      </div>
    </div>
  );
}